import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { MdCalendarToday, MdClose, MdError } from 'react-icons/md';
import consultationImage from '@/assets/images/trial_consultation.png';

import { TRIAL_BOOKING_URL } from '@/features/agent/trialConstants';

export default function TrialExpiringModal({
  open,
  onClose,
  trialDaysRemaining,
}: {
  open: boolean;
  onClose: () => void;
  trialDaysRemaining: number | null;
}) {
  const isLastDay = trialDaysRemaining === 0;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="w-[720px] max-w-[90vw] overflow-hidden rounded-xl p-0">
        <VisuallyHidden.Root>
          <DialogTitle>トライアル期間終了のお知らせ</DialogTitle>
        </VisuallyHidden.Root>

        <div className="relative flex flex-col items-center overflow-hidden p-10">
          <img
            src="/agent/trial/decorate-top.svg"
            alt=""
            className="pointer-events-none absolute top-0 right-0"
            aria-hidden="true"
          />

          <img
            src="/agent/trial/decorate-bottom.svg"
            alt=""
            className="pointer-events-none absolute bottom-0 left-0"
            aria-hidden="true"
          />

          <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-3 z-10 flex size-xxl items-center justify-center rounded-full bg-white hover:opacity-50"
          >
            <MdClose size={24} className="text-placeholder" />
          </button>

          <div className="relative z-[1] flex w-[527px] flex-col items-center justify-center p-lg">
            <div className="flex items-center gap-xs">
              <MdError size={50} className="text-danger" />
              <h2 className="text-center text-heading-md text-nowrap">
                {isLastDay ? (
                  <span>
                    <span className="text-danger">【本日終了】</span>
                    トライアル期間の最終日です
                  </span>
                ) : (
                  <span>
                    <span className="text-danger">【あと{trialDaysRemaining}日】</span>
                    間もなくトライアル期間が終了します
                  </span>
                )}
              </h2>
            </div>

            <img
              src={consultationImage}
              alt="オンライン相談"
              className="my-xl object-contain"
              width={217}
              height={199}
            />

            <div className="mb-xl w-[437px] text-center text-body-xs">
              {isLastDay ? (
                <>
                  これまでエージェントハブをご利用いただきありがとうございました。 <br />
                  <span className="text-tag-sm-highlight">
                    本日を過ぎますと、トライアル版の操作ができなくなります。{' '}
                  </span>
                  <br />
                  現在ご利用中のデータや設定は、製品版へそのまま引き継ぐことが可能です。 <br />
                  導入の進め方や費用、今後のデータ保持についてご不安な点は、本日中に無料相談をご予約ください。
                </>
              ) : (
                <>
                  いつもエージェントハブをご利用いただきありがとうございます。
                  <br />
                  <span className="text-tag-sm-highlight">
                    まもなくトライアル期間が終了し、使用が制限されます。
                  </span>
                  <br />
                  引き続きすべての機能を利用して業務を効率化したい方は、無料相談にて製品版への移行プランをご案内いたします。
                </>
              )}
            </div>

            <a
              href={TRIAL_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-[55px] w-full max-w-[399px] items-center justify-center gap-xxs rounded-full bg-[#005fff] text-button-lg text-white hover:text-white hover:opacity-90"
            >
              <MdCalendarToday size={20} />
              {isLastDay ? '本日中に無料相談を予約する' : '無料相談の空き状況を確認する'}
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
